import logo from './logo.svg';
import './App.css';
import { lazy } from 'react';
import Homepage from './Components/Homepage';
import 'bootstrap'
import Navbar from './Components/Navbar';
import Shop from './Components/Shop'
import { useState, useEffect } from 'react';
import Cart from './Components/cart';
import { Provider } from 'react-redux';
import { Store } from './Components/store/store';
import img1 from './Images/bag1.jpg'
import ProductSlider from './Components/ProductSlider';
import Gifts from './Components/CustomizedGift';
import ReturnPolicy from './Components/ReturnPolicy';
import OurStory from './Components/OurStory';
import ContactUs from './Components/ContactUs';
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { Gift } from 'react-bootstrap-icons';
import ErrorPage from './Error';
import Footer from './Components/footer';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from 'react-router-dom';
import ViewCart from './Components/ViewCart';
import Product from './Components/Product';
import Login from './Components/Login';
import Register from './Components/Register';
import Forgot from './Components/Forgot';
import OrderForm from './Components/OrderForm'
import DisplayUserData from './Components/DisplayUserData';
import Backend from './Components/Backend';
import { auth } from "./Components/Firebase";
import { getAuth } from "firebase/auth";
import Form from './Components/Form';
import CheckOut from './Components/CheckOut';


function App() {
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState('');

  // Display Name for Firebase
  const auth1 = getAuth();
  const user = auth1.currentUser;
    useEffect(() => {
      auth.onAuthStateChanged((user)=>{
        if (user) {
          setUserId(user.uid);
          setUserName(user.displayName);
        }
      })
      }, [user]);

  const [items, setItems] = useState([]);


  // Country
  useEffect(() => {
    fetch('http://api.ipify.org/')
      .then(response => response.text())
      .then(ip => {
        // console.log(ip)
        fetch('https://api.ipapi.com/api/' + ip)
        .then(response => response.text())
        .then(ip => {
          // console.log(ip)
        });
      });
  }, []);
  
  // On Unload
  function Unload() {
    alert("Window closed");
  }
  
  window.addEventListener("unload", Unload);
  
  // Uncomment while Uploading
  // useEffect(() => {
  //   // fetch('/backend/products/json')
  //   fetch('https://fakestoreapi.com/products')
  //     .then(res => res.json())
  //     .then(json => setItems(json))
  // }, [])
  // console.log(items)
  

  const products = [
    {
      id: 1,
      title: 'Canva Backpack',
      url: "https://static.wixstatic.com/media/a9ff3b_f852b0f8d589446d9b672173e24008f9.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/a9ff3b_f852b0f8d589446d9b672173e24008f9.webp",
      discountedPrice: 70.58,
      description: "This is the best product of the world",
      price: 65.50
    },
    {
      id: 2,
      title: 'Canva Backpack',
      url: "https://static.wixstatic.com/media/a9ff3b_b0e020a191534969bccc74fb5f27684c.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/a9ff3b_b0e020a191534969bccc74fb5f27684c.webp",
      discountedPrice: 70.58,
      description: "This is the best product of the world",
      price: 65.50
    },
    {
      id:3,
      title: 'Canva Backpack',
      url: "https://static.wixstatic.com/media/84770f_7b18884ff3e343208842ae1f30df28aa.jpg/v1/fill/w_827,h_827,al_c,q_85,usm_0.66_1.00_0.01/84770f_7b18884ff3e343208842ae1f30df28aa.webp",
      discountedPrice: 70.58,
      description: "This is the best product of the",
      price: 65.50
    }
  ];
  useEffect(() => {
  setItems(products);
}, [])
  return (
    <>
      <Provider store={Store} >
        <Router>
        <Navbar name={userName}></Navbar>
          <Routes>
            <Route path="/" errorElement={ErrorPage} exact element={<Homepage />} />
            <Route path="/shop" errorElement={ErrorPage} element={<Shop items={items} />} />
            <Route path="/get-in-touch" errorElement={ErrorPage} element={<ContactUs />} />
            <Route path="/return-policy" errorElement={ErrorPage} element={<ReturnPolicy />} />
            <Route path="/product" errorElement={ErrorPage} element={<Product item />} />
            <Route path="/story" errorElement={ErrorPage} element={<OurStory />} />
            <Route path="/cart" errorElement={ErrorPage} element={<ViewCart />} />
            <Route path="/login" errorElement={ErrorPage} element={<Login />} />
            <Route path="/register" errorElement={ErrorPage} element={<Register />} />
            <Route path="/forgot" errorElement={ErrorPage} element={<Forgot />} />
            <Route path='/user-info' element={<OrderForm />}></Route>
            <Route path='/user' element={<DisplayUserData />}></Route>
            <Route path='/backend' element={<Backend />}></Route>
            <Route path='/checkout-details' element={<Form />}></Route>
            <Route path='/checkout' element={<CheckOut/>}></Route>
          </Routes>
        </Router>
        <Footer></Footer>
      </Provider>
    </>
  );
}
export default App;
